import { Button, Center, Flex, VStack } from '@chakra-ui/react';
import type { FullscreenPopup } from 'types/cms/Globals';

import { TextContent } from './TextContent';

const MAX_SIZE = '480px';
const TOTAL_PADDING = '24px';

type ContentProps = Pick<FullscreenPopup, 'overlineText' | 'title' | 'link'> & {
  onClose: (action?: 'click' | 'close', url?: string) => void;
};

export function Content({ overlineText, title, link, onClose }: ContentProps) {
  return (
    <Center maxW="600px" h="100%" p="3xs">
      <Flex
        pos="relative"
        borderRadius="full"
        w={{
          base: `calc(100vw - ${TOTAL_PADDING})`,
          sm: `calc(${MAX_SIZE} - ${TOTAL_PADDING})`,
          md: MAX_SIZE,
        }}
        h={{
          base: `calc(100vw - ${TOTAL_PADDING})`,
          sm: `calc(${MAX_SIZE} - ${TOTAL_PADDING})`,
          md: MAX_SIZE,
        }}
        alignItems="center"
        justifyContent="center"
        bg="gray.50"
        py="70px"
        px="sm"
        boxShadow="md"
      >
        <VStack gap="sm">
          <TextContent overlineText={overlineText} title={title} />
          <Button
            as="a"
            href={link.href}
            onClick={() => onClose('click', link.href)}
          >
            {link.title}
          </Button>
          <Button
            variant="link"
            aria-label="Close"
            onClick={() => onClose('close')}
          >
            No thanks
          </Button>
        </VStack>
      </Flex>
    </Center>
  );
}
